import { render, staticRenderFns } from "./SchemaForm.vue?vue&type=template&id=741ce8f0"
import script from "./SchemaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports